<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<td>{{ 'adminstat.billing.billing.tariff' | translate }}</td>
				<td>{{ 'adminstat.common.userCount' | translate }}</td>
				<td>{{ 'adminstat.common.moneyCount' | translate }} $</td>
				<td>{{ 'adminstat.common.paidCount' | translate }}</td>
				<td>{{ 'adminstat.billing.billing.paidSiteCount' | translate }}</td>
				<td>{{ 'adminstat.common.sites' | translate }}</td>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let item of details">
				<td>
					{{ item.tariff }}
				</td>
				
				<td>
					{{ item.userCount }}
				</td>
				
				<td>
					{{ item.moneyCount / 100 }}
				</td>
				
				<td>
					{{ item.paidCount }}
				</td>
				
				<td>
					{{ item.siteCount }}
				</td>
				
				<td>
					<ul>
						<li *ngFor="let siteId of item.siteList | keys" style="list-style-type: none;">
							<site_info [siteUrl]="item.siteList[siteId].domainUrl" style="display: inline-block;"></site_info>
						</li>
					</ul>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
